import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { ShieldCheck, CircleNotch } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 relative bg-slate-900">
        <img src="https://images.unsplash.com/photo-1462556791646-c201b8241a94?w=1200&q=70"
          alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <ShieldCheck size={32} weight="fill" />
            <span className="font-semibold tracking-tight text-lg" style={{ fontFamily: "'Work Sans', sans-serif" }}>FraudGuard</span>
          </div>
          <div>
            <h1 className="text-4xl font-light tracking-tight leading-tight mb-4">
              Sistem Scoring<br />Klaim Asuransi
            </h1>
            <p className="text-slate-300 max-w-md text-sm leading-relaxed">
              Penilaian risiko fraud otomatis untuk klaim asuransi jiwa dan kendaraan.
              Rekomendasi investigasi, approval supervisor, dan penugasan investigator dalam satu platform.
            </p>
          </div>
          <p className="text-xs text-slate-400">Aplikasi internal perusahaan</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center bg-background p-8">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex items-center gap-2 mb-8 text-slate-900">
            <ShieldCheck size={28} weight="fill" />
            <span className="font-semibold text-lg">FraudGuard</span>
          </div>
          <h2 className="text-2xl font-semibold tracking-tight mb-1">Masuk</h2>
          <p className="text-sm text-muted-foreground mb-8">Gunakan akun internal perusahaan Anda</p>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email-input" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="nama@perusahaan.co.id" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password-input" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-red-600 border border-red-200 bg-red-50 px-3 py-2">{error}</p>}
            <Button data-testid="login-submit-button" type="submit" disabled={loading}
              className="w-full bg-slate-900 hover:bg-slate-800 rounded-none h-10">
              {loading ? <CircleNotch size={18} className="animate-spin" /> : "Masuk"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
